class NumberInput {
  public inputWrappers: NodeListOf<HTMLElement> | undefined;

  constructor(inputWrappers: NodeListOf<HTMLElement> | undefined = undefined) {
    if (inputWrappers) {
      this.inputWrappers = inputWrappers;
    }
  }

  bindings() {
    if (this.inputWrappers) {
      Object.values(this.inputWrappers).forEach((inputWrapper: HTMLElement) =>
        this.setInputBindings(inputWrapper)
      );
    }
  }

  cache() {
    if (!this.inputWrappers) {
      this.inputWrappers = document.querySelectorAll('.js-number-input');
    }
  }

  setInputBindings(inputWrapper: HTMLElement) {
    const input: HTMLInputElement | null = inputWrapper.querySelector('input');
    const plusButton: HTMLElement | null = inputWrapper.querySelector(
      '.js-number-input-plus'
    );
    const minusButton: HTMLElement | null = inputWrapper.querySelector(
      '.js-number-input-minus'
    );

    if (input) {
      if (plusButton) {
        plusButton.addEventListener('click', (e: Event) => {
          e.preventDefault();

          const value = Number(input.value) + 1;

          input.value =
            !input.max || value <= Number(input.max)
              ? String(value)
              : input.value;

          minusButton?.classList.remove('disabled');

          input.dispatchEvent(new Event('change'));
        });
      }

      if (minusButton) {
        minusButton.addEventListener('click', (e: Event) => {
          e.preventDefault();

          const value = Number(input.value) - 1;

          input.value =
            !input.min || value >= Number(input.min)
              ? String(value)
              : input.value;

          if (input.value === input.min) {
            minusButton.classList.add('disabled');
          }

          input.dispatchEvent(new Event('change'));
        });
      }
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default NumberInput;
